export default "__VITE_ASSET__BwnWb3Or__";